import wp from '../assets/pieces/default/wp.svg?url';
import wn from '../assets/pieces/default/wn.svg?url';
import wb from '../assets/pieces/default/wb.svg?url';
import wr from '../assets/pieces/default/wr.svg?url';
import wq from '../assets/pieces/default/wq.svg?url';
import wk from '../assets/pieces/default/wk.svg?url';
import bp from '../assets/pieces/default/bp.svg?url';
import bn from '../assets/pieces/default/bn.svg?url';
import bb from '../assets/pieces/default/bb.svg?url';
import br from '../assets/pieces/default/br.svg?url';
import bq from '../assets/pieces/default/bq.svg?url';
import bk from '../assets/pieces/default/bk.svg?url';
import type { PieceSymbol } from '../types/pieces';

// Define SVGs map
export const PIECE_SVGS: Record<PieceSymbol, string> = {
  wp, wn, wb, wr, wq, wk,
  bp, bn, bb, br, bq, bk
}; 